import {
  GET_LABREQUESTESSAY,
  GET_LABREQUESTESSAY_FAIL,
  GET_LABREQUESTESSAY_SUCCESS,
  GET_LABREQUESTESSAYS,
  GET_LABREQUESTESSAYS_FAIL,
  GET_LABREQUESTESSAYS_SUCCESS,
  ADD_NEW_LABREQUESTESSAY,
  ADD_LABREQUESTESSAY_SUCCESS,
  ADD_LABREQUESTESSAY_FAIL,
  UPDATE_LABREQUESTESSAY,
  UPDATE_LABREQUESTESSAY_SUCCESS,
  UPDATE_LABREQUESTESSAY_FAIL,
  DELETE_LABREQUESTESSAY,
  DELETE_LABREQUESTESSAY_SUCCESS,
  DELETE_LABREQUESTESSAY_FAIL,
  SET_STATE_LABREQUESTESSAY
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTESSAY,
  payload: loading,
})

export const getLabRequestEssays = ( params ) => ({
  type: GET_LABREQUESTESSAYS,
  payload: { params },
})

export const getLabRequestEssaysSuccess = (labRequestEssays, totalPages, currentPage) => ({
  type: GET_LABREQUESTESSAYS_SUCCESS,
  payload: { labRequestEssays:labRequestEssays, total:totalPages, currentPage:currentPage}
})

export const getLabRequestEssaysFail = error => ({
  type: GET_LABREQUESTESSAYS_FAIL,
  payload: error,
})

export const addNewLabRequestEssay = labRequestEssay => ({
  type: ADD_NEW_LABREQUESTESSAY,
  payload: labRequestEssay,
})

export const addLabRequestEssaySuccess = labRequestEssay => ({
  type: ADD_LABREQUESTESSAY_SUCCESS,
  payload: labRequestEssay,
})  

export const addLabRequestEssayFail = error => ({
  type: ADD_LABREQUESTESSAY_FAIL,
  payload: error,
})

export const updateLabRequestEssay = labRequestEssay => ({
  type: UPDATE_LABREQUESTESSAY,
  payload: labRequestEssay,
})

export const updateLabRequestEssaySuccess = labRequestEssay => ({
  type: UPDATE_LABREQUESTESSAY_SUCCESS,
  payload: labRequestEssay,
})

export const updateLabRequestEssayFail = error => ({
  type: UPDATE_LABREQUESTESSAY_FAIL,
  payload: error,
})

export const deleteLabRequestEssay = labRequestEssay => ({
  type: DELETE_LABREQUESTESSAY,
  payload: labRequestEssay,
})

export const deleteLabRequestEssaySuccess = id => ({
  type: DELETE_LABREQUESTESSAY_SUCCESS,
  id,
})

export const deleteLabRequestEssayFail = error => ({
  type: DELETE_LABREQUESTESSAY_FAIL,
  payload: error,
})

export const getLabRequestEssay = () => ({
  type: GET_LABREQUESTESSAY,
})

export const getLabRequestEssaySuccess = labRequestEssay => ({
  type: GET_LABREQUESTESSAY_SUCCESS,
  payload: labRequestEssay,
})

export const getLabRequestEssayFail = error => ({
  type: GET_LABREQUESTESSAY_FAIL,
  payload: error,
})
